import React from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordField({
  label,
  value,
  onChange,
  show,
  onToggle,
  autoComplete,
  placeholder,
  error,
}) {
  return (
    <div className="space-y-2">
      <label className="text-base font-semibold text-[#344054]">{label}</label>
      <div
        className={`flex items-center gap-3 rounded-xl border bg-white px-4 py-3 ${
          error ? "border-red-500 focus-within:ring-red-500" : "border-[#D0D5DD]"
        }`}
      >
        <input
          type={show ? "text" : "password"}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          autoComplete={autoComplete}
          placeholder={placeholder}
          className="w-full bg-transparent text-base font-medium text-[#344054] placeholder:text-[#98A2B3] focus:outline-none"
        />
        <button
          type="button"
          onClick={onToggle}
          className="text-base font-semibold text-[#61013B] transition hover:text-[#4d0130]"
        >
          {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
        </button>
      </div>
      {error && (
        <p className="text-sm font-medium text-red-500 mt-1">{error}</p>
      )}
    </div>
  );
}
